var map = {
	"./celebration.json": [
		9570,
		570
	],
	"./electric-guitar.json": [
		48004,
		4
	],
	"./lady-guitar.json": [
		64125,
		125
	],
	"./loading.json": [
		38692,
		692
	],
	"./speakers.json": [
		55795,
		795
	],
	"./trumpet.json": [
		6123,
		123
	],
	"./violin.json": [
		90257,
		257
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1931;
module.exports = webpackAsyncContext;